import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { withRouter } from 'react-router-dom';

import PracticeMap from './PracticeMap';

import { changeTablePropertiesPinnedRows } from '../../../../store/actions';
import { routeToTableSpecificScope } from "../../../../helpers/helpersts";
import { RootState } from "../../../../store/reducers";

type OwnProps = {
  match: { params: { id: string } };
  forceScope: string
};

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  const { id: practiceId } = ownProps.match.params;
  const path = state.router.location.pathname;
  const scope = ownProps.forceScope || routeToTableSpecificScope(path);
  return {
    blinks: state.dataEvents[practiceId].data.practiceViewer.blinks,
    hasBlinks: state.dataEvents[practiceId].data.practiceViewer.hasBlinks,
    pinnedRows: (state.tableProperties[scope] && state.tableProperties[scope].pinnedRows) || []
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators({
    changeTablePropertiesPinnedRows
  }, dispatch)
});
//@ts-ignore
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PracticeMap));